import React, { useEffect, useRef } from 'react';
import { useEntryPoint } from '@atlassian/jira-entry-point';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container';
import { JWM_INVITE_TEAM_NUDGE_ID } from '@atlassian/jira-onboarding-core/src/constants';
import { useHasNudgeActive, useNudgeStep } from '@atlassian/jira-onboarding-quickstart-core';
import { ERROR_BOUNDARY_ID_JWM_INVITE_TEAM_NUDGE } from '../../common/constants';
import type { WrapperProps } from '../../common/types';
import { useRegisterNudgeTarget } from '../../common/ui/portalled-nudge';
import { inviteTeamNudgeEntryPoint } from './entrypoint';

const runtimeProps = {};
const entryPointParams = {};
export const InviteTeamNudgeAsyncOld = ({ children }: WrapperProps) => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		inviteTeamNudgeEntryPoint,
		entryPointParams,
	);

	useEffect(() => {
		entryPointActions.load();
	}, [entryPointActions]);

	const { ref: inviteTeamNudgeRef } = useRegisterNudgeTarget<HTMLDivElement>(
		JWM_INVITE_TEAM_NUDGE_ID,
		true,
	);

	return (
		<>
			<span ref={inviteTeamNudgeRef}>{children}</span>
			<JiraEntryPointContainer
				id={ERROR_BOUNDARY_ID_JWM_INVITE_TEAM_NUDGE}
				packageName="jiraInviteTeamOnboarding"
				entryPointReferenceSubject={entryPointReferenceSubject}
				fallback={<></>}
				runtimeProps={runtimeProps}
			/>
		</>
	);
};

// the use of the code is behind a feature gate 'jwm_tailored_onboarding_invite_team_fix_gate'
export const InviteTeamNudgeAsync = () => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		inviteTeamNudgeEntryPoint,
		entryPointParams,
	);

	const [nudgeStep] = useNudgeStep();
	const [hasNudgeActive] = useHasNudgeActive();
	const firstLoadRef = useRef(true);

	useEffect(() => {
		if (firstLoadRef.current && hasNudgeActive && nudgeStep === JWM_INVITE_TEAM_NUDGE_ID) {
			entryPointActions.load();
			firstLoadRef.current = false;
		}
	}, [entryPointActions, hasNudgeActive, nudgeStep]);

	return (
		<JiraEntryPointContainer
			id={ERROR_BOUNDARY_ID_JWM_INVITE_TEAM_NUDGE}
			packageName="jiraInviteTeamOnboarding"
			entryPointReferenceSubject={entryPointReferenceSubject}
			fallback={<></>}
			runtimeProps={runtimeProps}
		/>
	);
};
